import dayjs from 'dayjs';

/* Not currently used
export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];*/

export enum DateFormat {
  complete = 'dddd, MMM D, YYYY',
  long = 'MMM D, YYYY',
  medium = 'ddd, M/D',
  short = 'M/D',
  htmlDateInput = 'YYYY-MM-DD'
}

export enum TimeFormat {
  standard = 'h:mma',
  htmlTimeInput = 'HH:mm'
}

export const formatTimestamp = (
  dateStr?: string,
  dateFormat?: DateFormat,
  timeFormat?: TimeFormat
): string => {
  if (!dateStr) return '';

  const parts: string[] = [];
  if (dateFormat) parts.push(dayjs(dateStr).format(dateFormat));
  if (timeFormat) parts.push(dayjs(dateStr).format(timeFormat));

  return parts.join(' @ ');
};

export const minutesToSeconds = minutes => minutes * 60;
export const hoursToSeconds = hours => hours * 60 * 60;
export const daysToSeconds = days => days * 24 * 60 * 60;

// Gets user-friendly string for elapsed time
export const getFormattedElapsedTimeFromMs = (ms: number) => {
  const seconds = Math.floor(ms / 1000);
  if (seconds < 60) return `${seconds} seconds`;

  const mins = Math.floor(seconds / 60);
  if (mins < 60) return `${mins} minutes`;

  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs} hours`;

  const days = Math.floor(hrs / 24);
  if (days < 30) return `${days} days`;

  const weeks = Math.floor(days / 7);
  if (weeks < 4) return `${weeks} weeks`;

  const months = Math.floor(weeks / 4);
  if (months < 12) return `${months} months`;

  const years = (weeks / 52).toFixed(1);
  return `${years} years`;
};
